<template lang="pug">
  .money.container
      .main-content__border_dsc
      .money__title
          span(v-html="tr.money.title")
      .money__subtitle
          span(v-html="tr.money.subtitle")
      .money__payment(v-if="!englishVersion && !mexicoVersion")
          each val in [1, 2, 6]
              img.money__img(src=`../../../assets/images/pay/money__img_${val}.png`, alt="")
      .money__payment(v-if="englishVersion || mexicoVersion")
        each val in [1, 2]
          img.money__img(src=`../../../assets/images/pay/money__img_${val}.png`, alt="")

      .money__dsc(v-html="tr.money.dsc")
</template>

<script>
import langOps from '@/mixins/langOps'
export default {
  data () {
    return {
      section: 'main'
    }
  },
  mixin: [langOps]
}
</script>

<style lang="scss">
  @import './style.scss';
</style>
